import { Link } from "react-router-dom";
import { Minus, Plus, X } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useStore } from "@/context/StoreContext";
import { formatPrice } from "@/lib/api";
import { t } from "@/lib/i18n";

const QtyControl = ({ item, updateQty }) => (
  <div className="inline-flex items-center border border-[#D5B98C]">
    <button data-testid={`cart-item-decrease-${item.key}`} onClick={() => updateQty(item.key, item.qty - 1)} className="p-1.5 hover:bg-[#D5B98C]/30"><Minus className="w-3 h-3" /></button>
    <span data-testid={`cart-item-qty-${item.key}`} className="w-7 text-center text-sm">{item.qty}</span>
    <button data-testid={`cart-item-increase-${item.key}`} onClick={() => updateQty(item.key, item.qty + 1)} className="p-1.5 hover:bg-[#D5B98C]/30"><Plus className="w-3 h-3" /></button>
  </div>
);

export const CartDrawer = () => {
  const { cart, cartOpen, setCartOpen, updateQty, removeFromCart, cartTotal } = useStore();
  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <SheetContent side="right" className="bg-[#F5F0E8] w-full sm:max-w-md p-0 flex flex-col" data-testid="cart-drawer">
        <div className="px-6 py-5 border-b border-[#D5B98C]/50">
          <SheetTitle className="font-serif text-2xl text-[#39251D] font-medium">{t("cart")}</SheetTitle>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-5">
          {cart.length === 0 && <p data-testid="cart-empty" className="text-sm text-[#242321]/60 py-10 text-center">{t("emptyCart")}</p>}
          {cart.map((i) => (
            <div key={i.key} data-testid={`cart-item-${i.key}`} className="flex gap-4">
              <img src={i.image} alt={i.name} className="w-20 h-24 object-cover" />
              <div className="flex-1 min-w-0">
                <div className="flex justify-between gap-2">
                  <Link to={`/prodotto/${i.slug}`} onClick={() => setCartOpen(false)} className="font-serif text-lg leading-tight text-[#39251D]">{i.name}</Link>
                  <button data-testid={`cart-item-remove-${i.key}`} onClick={() => removeFromCart(i.key)} className="text-[#242321]/50 hover:text-[#39251D]"><X className="w-4 h-4" /></button>
                </div>
                {i.variant && <div className="text-xs text-[#956842] mt-0.5">{i.variant}</div>}
                <div className="flex items-center justify-between mt-3">
                  <QtyControl item={i} updateQty={updateQty} />
                  <span className="text-sm font-medium">{formatPrice(i.price * i.qty)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        {cart.length > 0 && (
          <div className="px-6 py-5 border-t border-[#D5B98C]/50 space-y-3">
            <div className="flex justify-between text-sm">
              <span>Subtotale</span>
              <span data-testid="cart-subtotal" className="font-semibold">{formatPrice(cartTotal)}</span>
            </div>
            <p className="text-xs text-[#242321]/60">Spedizione Italia 6,90 €, gratuita da 99 € · UE 12,90 €, gratuita da 149 €. <Link to="/spedizioni" onClick={() => setCartOpen(false)} className="underline">Dettagli</Link></p>
            <Link to="/checkout" onClick={() => setCartOpen(false)} data-testid="cart-checkout-button" className="block w-full text-center bg-[#39251D] text-[#F5F0E8] py-3.5 text-xs uppercase tracking-[0.2em] hover:bg-[#956842] transition-colors">
              Procedi all'ordine
            </Link>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
